import { PostProperties } from "../types";
import image from "../img/lostGemJeromeSydenham.jpg";

const post: PostProperties = {
  id: 36,
  title: "Jerome Sydenham - Doornroosje, Nijmegen, Netherlands (19.01.2008)",
  content: `Jerome Sydenham is a highly respected Nigerian-born DJ, electronic music producer, and the founder of the respected label Ibadan Records. Currently based in Berlin, Jerome had a career that made him travel the globe and rock every dancefloor that he was able to touch. A producer who creates meaningful and creative pieces, Jerome has worked with some of the biggest names such as Kerri Chandler, Carl Craig, and others.`,
  image,
  buttonText: "Listen Here",
  buttonUrl:
    "https://soundcloud.com/shubinproject/jerome-sydenham-doornroosje-nijmegen-netherlands-19012008",
  category: "Lost Gem",
  translationsBg: {
    content: `Джером Сидънхам е високо уважаван диджей, роден в Нигерия, продуцент на електронна музика и основател на уважавания лейбъл Ibadan Records. В момента живее в Берлин и има кариера, която го кара да пътува по света и да разтърсва всеки дансинг, до който е успявал да се докосне. Като продуцент, който създава смислени и креативни парчета, Джером е работил с някои от най-големите имена като Кери Чандлър, Карл Крейг и други.`,
  },
};

export default post;
